export const colors = {
  // Brand colors
  primary: '#FF7E55',
  primaryHover: '#FF6B3C',
  primaryPressed: '#E6714C',
  primaryShadow: '#FF7E551E',
  secondary: '#463732',
  secondaryHover: '#FF7E551A',
  secondaryPressed: '#FF7E5533',
  premium: '#8A2BE2',
  premiumHover: '#943FE2',
  premiumPressed: '#8021D8',

  // Premium gradients
  gradients: {
    primary: ['#9E5EEE', '#B759EA', '#C65DE9', '#B885F4'],
    secondary: ['#9E5EEE', '#B759EA', '#C65DE9', '#B885F4'],
  },

  // Gray scale
  black: '#100D0B',
  gray1: '#131313',
  gray2: '#161311',
  gray3: '#1D1D1D',
  gray4: '#2B2B2B',
  gray5: '#6B6B6B',
  gray6: '#A9A9A9',
  white: '#FFFFFF',

  // State colors
  error: '#F04438',
  warning: '#E2B93B',
  success: '#079455',
  disabled: '#FFFFFF80',
  buttonDisabled: '#818181',
  buttonDisabledShadow: '#FF7E551E', // 12% opacity for disabled button shadow
} as const;

// Типы для цветов
export type ColorName = keyof typeof colors; 